import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  VesselScheduleItem,
  VesselScheduleItemForm,
  VesselScheduleItemsForm,
  VesselSchedulePages,
  VesselScheduleSearchQuery,
  ErrorVesselScheduleLockedD2dNos,
} from '@models/next/VesselSchedule';
import { z } from 'zod';

export const dashboardVesselScheduleApis = createApiHooks('/dashboard/vessel-schedule', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(VesselScheduleSearchQuery),
    response: VesselSchedulePages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Query',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: VesselScheduleItem,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: VesselScheduleItemsForm,
      },
    ],
    response: z.unknown(),
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: VesselScheduleItemForm,
      },
    ],
    errors: [{ status: 406, schema: ErrorVesselScheduleLockedD2dNos }],
    response: z.unknown(),
  },
  {
    method: 'delete',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'id',
        schema: z.number().array(),
      },
    ],
    response: z.unknown(),
  },
]);
